import ProtectionDonnees from '@/view/ProtectionDonnees/Protectiondonnees'

const TABLE_BREADCRUMB = {
  code: 'menu.politiqueProtectionDonnees',
}

export default [
  {
    path: '/politiqueProtectionDonnees',
    name: 'politiqueProtectionDonnees',
    component: ProtectionDonnees,
    meta: {
      auth: 'hasRole(ROLE_CORRESPONDANT,ROLE_PARTICIPANT)',
      breadcrumb: () => [TABLE_BREADCRUMB],
    },
  },
]
